import React, { useEffect, useState, useRef } from "react";
import * as Utils from '../../commons/utils/Utils';
import {
  TableRow,
} from '@material-ui/core';
import 'moment/min/locales';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import Loading from '../ui/Loading.js';
import moment from 'moment';
import Security from '../../commons/security/Security.js';
import swal from 'sweetalert2';
import { useIntl } from "react-intl";
import "react-datepicker/dist/react-datepicker.css";
import Config from '../../commons/config/Config.js';
import Modal from "@material-ui/core/Modal";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import ModalAccion from './ModalAccion.jsx';
import ReportesView from './ReportesView.jsx';

const ReportesGridRow = ({data, loading, reloadData, setLoading}) => {
  const [showModalAccion, setShowModalAccion] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [accion, setAccion] = useState(null);

  const useStylesCambioLlanta = makeStyles((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "15px",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "0px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      borderRadius: "15px",
      width: "600px",
    },
  }));

  const classesCambioLlanta = useStylesCambioLlanta();

  useEffect(() => {
  }, []);

  const handleConfirmar = (comentario) => {
    setLoading(true);
    Utils.sendData(`/safeFeedback/${data.id}/confirmar`, 'PATCH', { comentario })
    .then(() => {
      reloadData();
    })
    .finally(() => {
      setAccion(null)
      setLoading(false);
    });
  };

  const handleDesestimar = (comentario) => {
    setLoading(true);
    Utils.sendData(`/safeFeedback/${data.id}/desestimar`, 'PATCH', { comentario })
    .then(() => {
      reloadData();
    })
    .finally(() => {
      setAccion(null)
      setLoading(false);
    });
  };

  const openModalAccion = (accion) => {
    setAccion(accion)
    setShowModalAccion(true);
  };

  const closeModalAccion = () => {
    setAccion(null);
    setShowModalAccion(false);
  };

  return (
    <>
      {loading && <Loading />}
      <Modal
        open={showModalAccion}
        onClose={closeModalAccion}
        className={classesCambioLlanta.modal}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={showModalAccion}>
          <div className={classesCambioLlanta.paper}>
            <ModalAccion
              reporte={data}
              accion={accion}
              onClose={closeModalAccion}
              onConfirm={handleConfirmar}
              onDesestimar={handleDesestimar}
              loading={loading}
            />
          </div>
        </Fade>
      </Modal>
      <Modal
        open={showModalView}
        onClose={() => setShowModalView(false)}
        className={classesCambioLlanta.modal}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={showModalView}>
          <div className={classesCambioLlanta.paper}>
            <ReportesView
              reporte={data}
              onClose={() => setShowModalView(false)}
              loading={loading}
            />
          </div>
        </Fade>
      </Modal>
      <TableRow>
        <StyledTableCell align="left">
          {data.id}
        </StyledTableCell>
        <StyledTableCell align="left">
          {data.fecha}
        </StyledTableCell>
        <StyledTableCell align="left">
          {data.tipo_relato}
        </StyledTableCell>
        <StyledTableCell align="left">
          {data.tipo_ocurrencia}
        </StyledTableCell>
        <StyledTableCell align="left">
          {data.base_descripcion}
        </StyledTableCell>
        <StyledTableCell align="left">
          {data.persona_involucrada}
        </StyledTableCell>
        <StyledTableCell align="left">
          {data.dominio}
        </StyledTableCell>
        <StyledTableCell align="left">
          <div className="d-inline-flex">
            {data.estado === "PENDIENTE" && Security.hasPermission('SAFEFEEDBACK_GESTIONAR_REPORTES') ? (
              <>
                <button
                  className="action approve btn btn-sm btn-icon btn-dt-grid text-success"
                  data-title="Confirmar"
                  data-toggle="tooltip"
                  data-placement="top"
                  onClick={() => openModalAccion('confirmar')}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
                <button
                  className="action approve btn btn-sm btn-icon btn-dt-grid text-success"
                  data-title="Desestimar"
                  data-toggle="tooltip"
                  data-placement="top"
                  onClick={() => openModalAccion('desestimar')}
                >
                  <i className="fas fa-times-circle fa-xs" style={{color: "red"}}></i>
                </button>
              </>
            ) : ''}
            <button
              className="action view btn btn-sm btn-icon btn-dt-grid text-success"
              data-title="Ver"
              data-togle="tooltip"
              data-placement="top"
              onClick={() => setShowModalView(true)}
            >
              <i className="fa fa-search fa-xs" />
            </button>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  )
}

export default ReportesGridRow
